import React from "react";
import { Badge } from "../shared";

export default function MasterToggle({ enabled, onChange }) {
  return (
    <div className="mcp-master-toggle">
      <div className="mcp-master-toggle-info">
        <h4 className="mcp-master-toggle-title">AI agent access</h4>
        <Badge variant={enabled ? "green" : "red"}>
          {enabled ? "Active" : "Disabled"}
        </Badge>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        className={`mcp-toggle mcp-toggle-lg ${
          enabled ? "mcp-toggle-on" : "mcp-toggle-off"
        }`}
        onClick={() => onChange(!enabled)}
      >
        <span className="mcp-toggle-knob" />
      </button>
    </div>
  );
}
